// src/index.ts
var StructuredRegEx = class extends RegExp {
  constructor(pattern, mapping) {
    super(pattern);
    this.mapping = mapping;
  }
  parse(str) {
    const match = str.match(this);
    if (!match) return null;
    const ret = {};
    Object.entries(this.mapping).forEach(([key, index]) => {
      ret[key] = match[index];
    });
    return ret;
  }
};
export {
  StructuredRegEx
};
//# sourceMappingURL=index.mjs.map